module.exports = {"components":{"entity-change-log":{"titles":{"contact":"Contact changelog","rsvp":"Rsvp changelog","voucher":"Voucher Action-Log"}}},"store":{"templates":{"meta_data":{"changed_fields":"Changed fields: "}}},"pages":{"list":{"tabs":{"list":"List","changelog":"Changelog"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/action-log.json
// module id = 2384
// module chunks = 1